export default __webpack_public_path__ + "static/media/CNo.76-2.3c2546ec.jpg";